module.exports = __webpack_public_path__ + "static/media/bg_map.67f22bfe.png";